const isPartnerLocation = ({ pathname }) => !!pathname?.includes('/partners')

export { isPartnerLocation }
